import hasOpenTokSupportHelpers from '../helpers/hasOpenTokSupport';
import env from '../helpers/env';

const { name } = env;

const hasOpenTokSupport = hasOpenTokSupportHelpers.once;

export default () =>
  hasOpenTokSupport() && ['Chrome', 'Samsung', 'Firefox', 'Safari'].indexOf(name) > -1;
